export const ProductPartition = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Ad Group Product Partition',
    },
    BidAmount: {
      'bulk-upload-header': 'Bid',
    },
    BidBoost: {
      'bulk-upload-header': 'Bid Adjustment',
    },
    ProductCondition: {
      'bulk-upload-header': 'Product Condition 1',
    },
    ProductValue: {
      'bulk-upload-header': 'Product Value 1',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
    IsLeaf: {
      'bulk-upload-header': 'Sub Type',
    },
    IsExcluded: {
      'bulk-upload-header': 'Is Excluded',
      'bulk-upload-mapper': function (value) {
        return value ? 'yes' : 'no';
      },
    },
  },
};
